import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const StyledButton = styled(Button)`
  &.ant-btn {
    border-radius: var(--radius-sm);
    font-family: 'Outfit', sans-serif;
    font-weight: 500;
    transition: var(--transition-smooth);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: auto;
    padding: 10px 24px;
    border: 1px solid transparent;

    &.ant-btn-primary {
      background: var(--waya-red);
      color: white;
      box-shadow: 0 4px 14px 0 rgba(231, 71, 44, 0.2);

      &:hover, &:focus {
        background: var(--waya-red-hover) !important;
        transform: translateY(-1px);
        box-shadow: 0 6px 20px rgba(231, 71, 44, 0.25) !important;
      }
    }

    &.ant-btn-default {
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(8px);
      border-color: rgba(0, 0, 0, 0.1);
      color: var(--text-main);

      &:hover, &:focus {
        background: rgba(255, 255, 255, 0.8) !important;
        border-color: var(--waya-red) !important;
        color: var(--waya-red) !important;
      }
    }

    &.ant-btn-text {
      color: var(--text-muted);
      &:hover {
        color: var(--waya-red);
        background: var(--waya-red-glass);
      }
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

const PremiumButton = ({ children, icon, ...props }) => {
  return (
    <StyledButton icon={icon} {...props}>
      {children}
    </StyledButton>
  );
};

PremiumButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node,
};

export default PremiumButton;
